(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["as-cl-0050"] && !Shopify.designMode) return;
  try {
     
  const buttons = document.querySelectorAll('.cl-0050-navigation button');
  buttons.forEach((button) => button.addEventListener('click', (event) => {
    event.preventDefault();

    const { index } = button.dataset;

    //Remove all active and add all hidden
    buttons.forEach((button) => button.classList.remove('active'));
    button.classList.add('active');

    //Find other carousels
    const all = document.querySelectorAll('.as-cl-0050 .featured-collection--carousel[data-index]')
    all.forEach((carousel) => carousel.classList.remove('active'));

    //Find Target
    const target = document.querySelector(`.as-cl-0050 .featured-collection--carousel[data-index="${index}"]`);
    if(!target) {
      console.error("CL-0050", target, "Not found");
    }

    target.classList.add('active');
  }))

  } catch(e) { console.error(e); }
})();
})();
